// // src/components/forms/MemberForm.jsx
// import React, { useState } from 'react';
// import { CheckCircle, AlertCircle, Upload, ShieldCheck, Clock } from 'lucide-react';
// import './MemberForm.css';

// export default function MemberForm() {
//   const [formData, setFormData] = useState({
//     fullName: '',
//     email: '',
//     mobile: '',
//     clubName: '',
//     district: '320A',
//     membershipNumber: '',
//     aadharNumber: '',
//     postalAddress: ''
//   });

//   const [photo, setPhoto] = useState(null);
//   const [photoPreview, setPhotoPreview] = useState(null);

//   // Aadhaar Verification State
//   const [otpSent, setOtpSent] = useState(false);
//   const [refId, setRefId] = useState('');
//   const [otp, setOtp] = useState('');
//   const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
//   const [aadhaarLoading, setAadhaarLoading] = useState(false);

//   // Form Submission Status
//   const [loading, setLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');

//   const districtOptions = ['320A', '320B', '320C', '320D', '320E', '320F', '320G', '320H'];

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handlePhotoSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setPhoto(file);
//       setPhotoPreview(URL.createObjectURL(file));
//     }
//   };

//   // 1. Send OTP to Aadhaar registered number
//   const handleSendAadhaarOtp = async () => {
//     if (!formData.aadharNumber || formData.aadharNumber.length < 12) {
//       setErrorMessage('Please enter a valid 12-digit Aadhaar number.');
//       return;
//     }
//     setAadhaarLoading(true);
//     setErrorMessage('');

//     try {
//       const response = await fetch('https://api.lbnhyderabad.com/api/member/send-aadhar-otp', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ Aadhar_No: formData.aadharNumber })
//       });
//       const data = await response.json();

//       if (!response.ok || !data.success) {
//         throw new Error(data.message || 'Failed to send OTP');
//       }

//       setRefId(data.ref_id);
//       setOtpSent(true);
//     } catch (err) {
//       setErrorMessage(err.message);
//     } finally {
//       setAadhaarLoading(false);
//     }
//   };

//   // 2. Verify Aadhaar OTP
//   const handleVerifyAadhaarOtp = async () => {
//     if (!otp) {
//       setErrorMessage('Please enter the OTP received on your mobile.');
//       return;
//     }
//     setAadhaarLoading(true);
//     setErrorMessage('');

//     try {
//       const response = await fetch('https://api.lbnhyderabad.com/api/member/verify-aadhar-otp', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           otp,
//           ref_id: refId,
//           Aadhar_No: formData.aadharNumber
//         })
//       });
//       const data = await response.json();

//       if (!response.ok || !data.success) {
//         throw new Error(data.message || 'OTP Verification failed');
//       }

//       setIsAadhaarVerified(true);
//       if (data.verifiedName && !formData.fullName) {
//         setFormData(prev => ({ ...prev, fullName: data.verifiedName }));
//       }
//     } catch (err) {
//       setErrorMessage(err.message);
//     } finally {
//       setAadhaarLoading(false);
//     }
//   };

//   // 3. Final Onboarding Submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setErrorMessage('');
//     setSuccessMessage('');

//     if (!isAadhaarVerified) {
//       setErrorMessage('Please verify your Aadhaar via OTP before submitting the application.');
//       return;
//     }

//     setLoading(true);

//     try {
//       const dataPayload = new FormData();
//       Object.keys(formData).forEach((key) => {
//         dataPayload.append(key, formData[key]);
//       });
//       dataPayload.append('aadhaarVerified', isAadhaarVerified);
//       if (photo) {
//         dataPayload.append('photo', photo);
//       }

//       const response = await fetch('https://api.lbnhyderabad.com/api/member/register', {
//         method: 'POST',
//         body: dataPayload
//       });

//       const resData = await response.json();
//       if (!response.ok || !resData.success) {
//         throw new Error(resData.message || 'Failed to complete registration');
//       }

//       setSuccessMessage(resData.message);
//     } catch (err) {
//       setErrorMessage(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="member-onboard-viewport">
//       <div className="member-form-card">
//         {/* Banner Header */}
//         <div className="member-header-banner">
//           <h1>Privilege Card Membership</h1>
//           <p>Complete your enrollment for exclusive member access, supplier privileges, and digital identity benefits.</p>
//         </div>

//         <div className="member-form-body">
//           {errorMessage && (
//             <div style={{ background: '#fee2e2', color: '#991b1b', padding: '12px 16px', borderRadius: '10px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
//               <AlertCircle size={20} />
//               <span>{errorMessage}</span>
//             </div>
//           )}

//           {successMessage ? (
//             <div style={{ textAlign: 'center', padding: '40px 20px' }}>
//               <CheckCircle size={64} color="#166534" style={{ margin: '0 auto 16px' }} />
//               <h2 style={{ color: '#00529b', fontFamily: 'Playfair Display, serif', fontSize: '1.8rem', marginBottom: '10px' }}>Application Submitted</h2>
//               <p style={{ color: '#475569', maxWidth: '520px', margin: '0 auto 20px', lineHeight: '1.6' }}>
//                 {successMessage}
//               </p>
//               <div className="delivery-notice" style={{ display: 'inline-block', textAlign: 'left' }}>
//                 <Clock size={18} style={{ verticalAlign: 'middle', marginRight: '6px' }} />
//                 Approved membership cards feature an estimated delivery time of 1 month to your registered postal address.
//               </div>
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit}>
//               {/* Photo Upload Row */}
//               <div className="form-group-full">
//                {/* Executive Photo Upload Row */}
// <div className="photo-upload-section">
//   <label className="field-label">Member Photograph (Passport Style)</label>

//   <div className="photo-upload-container">
//     {/* Circular Avatar Frame */}
//     <div className="photo-avatar-wrapper">
//       {photoPreview ? (
//         <img src={photoPreview} alt="Member Preview" className="photo-avatar-img" />
//       ) : (
//         <div className="photo-avatar-placeholder">
//           <Upload size={30} className="placeholder-icon" />
//           <span>Upload</span>
//         </div>
//       )}

//       {/* Floating Action Trigger */}
//       <label htmlFor="member-photo-input" className="photo-badge-btn" title="Choose Photo">
//         <Upload size={14} />
//       </label>
//       <input
//         id="member-photo-input"
//         type="file"
//         accept="image/png, image/jpeg, image/jpg"
//         onChange={handlePhotoSelect}
//         style={{ display: 'none' }}
//         required={!photo}
//       />
//     </div>

//     {/* Instructions & Change Controls */}
//     <div className="photo-upload-meta">
//       <div className="meta-actions">
//         <label htmlFor="member-photo-input" className="btn-photo-action">
//           {photoPreview ? 'Change Photograph' : 'Choose Photograph'}
//         </label>
//         {photoPreview && (
//           <button
//             type="button"
//             className="btn-photo-remove"
//             onClick={() => {
//               setPhoto(null);
//               setPhotoPreview(null);
//             }}
//           >
//             Remove
//           </button>
//         )}
//       </div>
//       <p className="photo-help-text">
//         High-resolution portrait with clear front face view. Standard passport ratio (JPG or PNG, max 5MB).
//       </p>
//     </div>
//   </div>
// </div>
//               </div>

//               {/* Grid 1: Name & Email */}
//               <div className="form-grid-2">
//                 <div>
//                   <label className="field-label">Full Name</label>
//                   <input className="input-lux" type="text" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="e.g. Rajesh Kumar" required />
//                 </div>
//                 <div>
//                   <label className="field-label">Email Address</label>
//                   <input className="input-lux" type="email" name="email" value={formData.email} onChange={handleChange} placeholder="rajesh@example.com" required />
//                 </div>
//               </div>

//               {/* Grid 2: Mobile & Club Name */}
//               <div className="form-grid-2">
//                 <div>
//                   <label className="field-label">Mobile Number</label>
//                   <input className="input-lux" type="tel" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="+91 98765 43210" required />
//                 </div>
//                    <div>
//                   <label className="field-label">Membership Number</label>
//                   <input className="input-lux" type="text" name="membershipNumber" value={formData.membershipNumber} onChange={handleChange} placeholder="Membership Id" required />
//                 </div>
             
//               </div>

//               {/* Grid 3: District & Membership Number */}
//               <div className="form-grid-2">
//                 <div>
//                   <label className="field-label">District</label>
//                   <select className="input-lux" name="district" value={formData.district} onChange={handleChange}>
//                     {districtOptions.map((dist) => (
//                       <option key={dist} value={dist}>{dist}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div>
//                   <label className="field-label">Club Name</label>
//                   <input className="input-lux" type="text" name="clubName" value={formData.clubName} onChange={handleChange} placeholder="Enter your club" required />
//                 </div>
//               </div>

//               {/* Aadhaar Verification Box */}
//               <div className="aadhaar-box">
//                 <label className="field-label">Aadhaar Validation</label>
//                 <div className="aadhaar-action-row">
//                   <input
//                     className="input-lux"
//                     type="password"
//                     name="aadharNumber"
//                     maxLength={12}
//                     value={formData.aadharNumber}
//                     onChange={handleChange}
//                     placeholder="Enter 12-digit Aadhaar Number"
//                     disabled={isAadhaarVerified}
//                     required
//                   />
//                   {!isAadhaarVerified && !otpSent && (
//                     <button type="button" className="btn-verify-action" onClick={handleSendAadhaarOtp} disabled={aadhaarLoading}>
//                       {aadhaarLoading ? 'Sending...' : 'Send OTP'}
//                     </button>
//                   )}
//                 </div>

//                 {otpSent && !isAadhaarVerified && (
//                   <div style={{ marginTop: '14px' }}>
//                     <div className="aadhaar-action-row">
//                       <input
//                         className="input-lux"
//                         type="text"
//                         placeholder="Enter 6-digit OTP"
//                         value={otp}
//                         onChange={(e) => setOtp(e.target.value)}
//                       />
//                       <button type="button" className="btn-verify-action" onClick={handleVerifyAadhaarOtp} disabled={aadhaarLoading}>
//                         {aadhaarLoading ? 'Verifying...' : 'Verify OTP'}
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {isAadhaarVerified && (
//                   <div className="verified-badge">
//                     <ShieldCheck size={16} /> Aadhaar Identity Verified
//                   </div>
//                 )}
//               </div>

//               {/* Postal Address */}
//               <div className="form-group-full">
//                 <label className="field-label">Postal Address (For Card Delivery)</label>
//                 <textarea
//                   className="input-lux"
//                   rows={3}
//                   name="postalAddress"
//                   value={formData.postalAddress}
//                   onChange={handleChange}
//                   placeholder="Door No, Street, Landmark, Village/City, PIN Code"
//                   required
//                 />
//               </div>

//               {/* Delivery Notice */}
//               <div className="delivery-notice">
//                 <strong>Delivery Timeline:</strong> Automated confirmation is dispatched upon application submission, pending subscription payment and admin approval. Approved membership cards feature an estimated delivery time of 1 month to the postal address.
//               </div>

//               <button type="submit" className="btn-submit-lux" disabled={loading}>
//                 {loading ? 'Submitting Application...' : 'Submit Application'}
//               </button>
//             </form>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// src/components/forms/MemberForm.jsx
import React, { useState, useEffect } from 'react';
import { 
  CheckCircle, 
  AlertCircle, 
  Upload, 
  ShieldCheck, 
  Clock, 
  FileText, 
  FileCheck, 
  Check, 
  X, 
  ExternalLink 
} from 'lucide-react';
import './MemberForm.css';

const API_BASE_URL = 'https://api.lbnhyderabad.com';

export default function MemberForm() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobile: '',
    clubName: '',
    district: '320A',
    membershipNumber: '',
    aadharNumber: '',
    postalAddress: ''
  });

  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);

  // Aadhaar Verification State
  const [otpSent, setOtpSent] = useState(false);
  const [refId, setRefId] = useState('');
  const [otp, setOtp] = useState('');
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  const [aadhaarLoading, setAadhaarLoading] = useState(false);

  // Legal Policies State
  const [legalDocs, setLegalDocs] = useState({});
  const [activeModalDoc, setActiveModalDoc] = useState(null);
  const [agreedDocs, setAgreedDocs] = useState({
    terms_of_use: false,
    disclaimer: false,
    privacy_policy: false
  });
  const [masterConfirmed, setMasterConfirmed] = useState(false);

  // Form Submission Status
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const districtOptions = ['320A', '320B', '320C', '320D', '320E', '320F', '320G', '320H'];

  // Fetch Legal Documents from Database
  useEffect(() => {
    fetch(`https://api.lbnhyderabad.com/api/member/legal-documents`)
      .then(res => res.json())
      .then(json => {
        if (json.success && json.data) {
          const mapped = {};
          json.data.forEach(d => { mapped[d.doc_key] = d; });
          setLegalDocs(mapped);
        }
      })
      .catch(err => console.error('Failed to load dynamic policies:', err));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePhotoSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhoto(file);
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  // 1. Send OTP to Aadhaar registered number
  const handleSendAadhaarOtp = async () => {
    if (!formData.aadharNumber || formData.aadharNumber.length < 12) {
      setErrorMessage('Please enter a valid 12-digit Aadhaar number.');
      return;
    }
    setAadhaarLoading(true);
    setErrorMessage('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/member/send-aadhar-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Aadhar_No: formData.aadharNumber })
      });
      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Failed to send OTP');
      }

      setRefId(data.ref_id);
      setOtpSent(true);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setAadhaarLoading(false);
    }
  };

  // 2. Verify Aadhaar OTP
  const handleVerifyAadhaarOtp = async () => {
    if (!otp) {
      setErrorMessage('Please enter the OTP received on your mobile.');
      return;
    }
    setAadhaarLoading(true);
    setErrorMessage('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/member/verify-aadhar-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          otp,
          ref_id: refId,
          Aadhar_No: formData.aadharNumber
        })
      });
      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || 'OTP Verification failed');
      }

      setIsAadhaarVerified(true);
      if (data.verifiedName && !formData.fullName) {
        setFormData(prev => ({ ...prev, fullName: data.verifiedName }));
      }
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setAadhaarLoading(false);
    }
  };

  // Mark single policy agreement from inside modal
  const handleAgreeSingleDoc = (key) => {
    setAgreedDocs(prev => ({ ...prev, [key]: true }));
    setActiveModalDoc(null);
  };

  // Check if all 3 policies have been agreed to
  const allPoliciesAgreed = agreedDocs.terms_of_use && agreedDocs.disclaimer && agreedDocs.privacy_policy;

  // 3. Final Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (!isAadhaarVerified) {
      setErrorMessage('Please verify your Aadhaar via OTP before submitting the application.');
      return;
    }

    if (!allPoliciesAgreed || !masterConfirmed) {
      setErrorMessage('You must review and agree to all 3 legal policy declarations (Terms, Disclaimer, Privacy Policy) to proceed.');
      return;
    }

    setLoading(true);

    try {
      const dataPayload = new FormData();
      Object.keys(formData).forEach((key) => {
        dataPayload.append(key, formData[key]);
      });
      dataPayload.append('aadhaarVerified', isAadhaarVerified);
      dataPayload.append('termsAgreed', 'true');
      if (photo) {
        dataPayload.append('photo', photo);
      }

      const response = await fetch(`${API_BASE_URL}/api/member/register`, {
        method: 'POST',
        body: dataPayload
      });

      const resData = await response.json();
      if (!response.ok || !resData.success) {
        throw new Error(resData.message || 'Failed to complete registration');
      }

      setSuccessMessage(resData.message);
    } catch (err) {
      setErrorMessage(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="member-onboard-viewport">
      {/* ================= POLICY DETAIL MODAL ================= */}
      {activeModalDoc && (
        <div className="legal-modal-backdrop">
          <div className="legal-modal-box">
            <div className="legal-modal-header">
              <h3>{legalDocs[activeModalDoc]?.title || 'Policy Document'}</h3>
              <button 
                type="button" 
                className="btn-legal-close" 
                onClick={() => setActiveModalDoc(null)}
              >
                <X size={18} />
              </button>
            </div>

            <div 
              className="legal-modal-scroll" 
              dangerouslySetInnerHTML={{ 
                __html: legalDocs[activeModalDoc]?.content_html || '<p>Loading document text...</p>' 
              }} 
            />

            <div className="legal-modal-footer">
              <span style={{ fontSize: '0.74rem', color: '#64748b' }}>
                Version {legalDocs[activeModalDoc]?.version || '1.0'} • LBN MD320 Society
              </span>
              <button
                type="button"
                className="btn-agree-doc"
                onClick={() => handleAgreeSingleDoc(activeModalDoc)}
              >
                <Check size={14} />
                <span>I Have Read &amp; Agree</span>
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="member-form-card">
        {/* Banner Header */}
        <div className="member-header-banner">
          <h1>Privilege Card Membership</h1>
          <p>Complete your enrollment for exclusive member access, supplier privileges, and digital identity benefits.</p>
        </div>

        <div className="member-form-body">
          {errorMessage && (
            <div style={{ background: '#fee2e2', color: '#991b1b', padding: '12px 16px', borderRadius: '10px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AlertCircle size={20} />
              <span>{errorMessage}</span>
            </div>
          )}

          {successMessage ? (
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <CheckCircle size={64} color="#166534" style={{ margin: '0 auto 16px' }} />
              <h2 style={{ color: '#00529b', fontFamily: 'Playfair Display, serif', fontSize: '1.8rem', marginBottom: '10px' }}>Application Submitted</h2>
              <p style={{ color: '#475569', maxWidth: '520px', margin: '0 auto 20px', lineHeight: '1.6' }}>
                {successMessage}
              </p>
              <div className="delivery-notice" style={{ display: 'inline-block', textAlign: 'left' }}>
                <Clock size={18} style={{ verticalAlign: 'middle', marginRight: '6px' }} />
                Approved membership cards feature an estimated delivery time of 1 month to your registered postal address.
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {/* Photo Upload Row */}
              <div className="form-group-full">
                <div className="photo-upload-section">
                  <label className="field-label">Member Photograph (Passport Style)</label>
                  <div className="photo-upload-container">
                    <div className="photo-avatar-wrapper">
                      {photoPreview ? (
                        <img src={photoPreview} alt="Member Preview" className="photo-avatar-img" />
                      ) : (
                        <div className="photo-avatar-placeholder">
                          <Upload size={30} className="placeholder-icon" />
                          <span>Upload</span>
                        </div>
                      )}
                      <label htmlFor="member-photo-input" className="photo-badge-btn" title="Choose Photo">
                        <Upload size={14} />
                      </label>
                      <input
                        id="member-photo-input"
                        type="file"
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={handlePhotoSelect}
                        style={{ display: 'none' }}
                        required={!photo}
                      />
                    </div>

                    <div className="photo-upload-meta">
                      <div className="meta-actions">
                        <label htmlFor="member-photo-input" className="btn-photo-action">
                          {photoPreview ? 'Change Photograph' : 'Choose Photograph'}
                        </label>
                        {photoPreview && (
                          <button
                            type="button"
                            className="btn-photo-remove"
                            onClick={() => {
                              setPhoto(null);
                              setPhotoPreview(null);
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                      <p className="photo-help-text">
                        High-resolution portrait with clear front face view. Standard passport ratio (JPG or PNG, max 5MB).
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Grid 1: Name & Email */}
              <div className="form-grid-2">
                <div>
                  <label className="field-label">Full Name</label>
                  <input className="input-lux" type="text" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="e.g. Rajesh Kumar" required />
                </div>
                <div>
                  <label className="field-label">Email Address</label>
                  <input className="input-lux" type="email" name="email" value={formData.email} onChange={handleChange} placeholder="rajesh@example.com" required />
                </div>
              </div>

              {/* Grid 2: Mobile & Membership Number */}
              <div className="form-grid-2">
                <div>
                  <label className="field-label">Mobile Number</label>
                  <input className="input-lux" type="tel" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="+91 98765 43210" required />
                </div>
                <div>
                  <label className="field-label">Membership Number</label>
                  <input className="input-lux" type="text" name="membershipNumber" value={formData.membershipNumber} onChange={handleChange} placeholder="Membership Id" required />
                </div>
              </div>

              {/* Grid 3: District & Club Name */}
              <div className="form-grid-2">
                <div>
                  <label className="field-label">District</label>
                  <select className="input-lux" name="district" value={formData.district} onChange={handleChange}>
                    {districtOptions.map((dist) => (
                      <option key={dist} value={dist}>{dist}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="field-label">Club Name</label>
                  <input className="input-lux" type="text" name="clubName" value={formData.clubName} onChange={handleChange} placeholder="Enter your club" required />
                </div>
              </div>

              {/* Aadhaar Verification Box */}
              <div className="aadhaar-box">
                <label className="field-label">Aadhaar Validation</label>
                <div className="aadhaar-action-row">
                  <input
                    className="input-lux"
                    type="password"
                    name="aadharNumber"
                    maxLength={12}
                    value={formData.aadharNumber}
                    onChange={handleChange}
                    placeholder="Enter 12-digit Aadhaar Number"
                    disabled={isAadhaarVerified}
                    required
                  />
                  {!isAadhaarVerified && !otpSent && (
                    <button type="button" className="btn-verify-action" onClick={handleSendAadhaarOtp} disabled={aadhaarLoading}>
                      {aadhaarLoading ? 'Sending...' : 'Send OTP'}
                    </button>
                  )}
                </div>

                {otpSent && !isAadhaarVerified && (
                  <div style={{ marginTop: '14px' }}>
                    <div className="aadhaar-action-row">
                      <input
                        className="input-lux"
                        type="text"
                        placeholder="Enter 6-digit OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                      <button type="button" className="btn-verify-action" onClick={handleVerifyAadhaarOtp} disabled={aadhaarLoading}>
                        {aadhaarLoading ? 'Verifying...' : 'Verify OTP'}
                      </button>
                    </div>
                  </div>
                )}

                {isAadhaarVerified && (
                  <div className="verified-badge">
                    <ShieldCheck size={16} /> Aadhaar Identity Verified
                  </div>
                )}
              </div>

              {/* Postal Address */}
              <div className="form-group-full">
                <label className="field-label">Postal Address (For Card Delivery)</label>
                <textarea
                  className="input-lux"
                  rows={3}
                  name="postalAddress"
                  value={formData.postalAddress}
                  onChange={handleChange}
                  placeholder="Door No, Street, Landmark, Village/City, PIN Code"
                  required
                />
              </div>

              {/* ================= 3 MANDATORY POLICY AGREEMENTS ================= */}
              <div className="compliance-section-box">
                <div className="compliance-head-row">
                  <div className="compliance-title">
                    <ShieldCheck size={18} color="#00529b" />
                    <span>Statutory &amp; Membership Declarations</span>
                  </div>
                  <span className={`compliance-status-pill ${allPoliciesAgreed && masterConfirmed ? 'complete' : 'pending'}`}>
                    {allPoliciesAgreed && masterConfirmed ? 'Completed' : 'Review Required'}
                  </span>
                </div>

                <p className="compliance-subtext">
                  Please review each document below. You must accept all 3 policies to enable submission.
                </p>

                {/* 3 Buttons to open modals */}
                <div className="compliance-action-grid">
                  {/* Document 1: Terms of Use */}
                  <button
                    type="button"
                    className={`btn-policy-doc ${agreedDocs.terms_of_use ? 'agreed' : ''}`}
                    onClick={() => setActiveModalDoc('terms_of_use')}
                  >
                    <span>1. Terms of Use</span>
                    <span className="policy-badge-state">
                      {agreedDocs.terms_of_use ? <><Check size={13} /> Agreed</> : 'Review & Agree'}
                    </span>
                  </button>

                  {/* Document 2: Merchant Disclaimer */}
                  <button
                    type="button"
                    className={`btn-policy-doc ${agreedDocs.disclaimer ? 'agreed' : ''}`}
                    onClick={() => setActiveModalDoc('disclaimer')}
                  >
                    <span>2. Merchant Disclaimer</span>
                    <span className="policy-badge-state">
                      {agreedDocs.disclaimer ? <><Check size={13} /> Agreed</> : 'Review & Agree'}
                    </span>
                  </button>

                  {/* Document 3: Privacy Policy */}
                  <button
                    type="button"
                    className={`btn-policy-doc ${agreedDocs.privacy_policy ? 'agreed' : ''}`}
                    onClick={() => setActiveModalDoc('privacy_policy')}
                  >
                    <span>3. Privacy Policy</span>
                    <span className="policy-badge-state">
                      {agreedDocs.privacy_policy ? <><Check size={13} /> Agreed</> : 'Review & Agree'}
                    </span>
                  </button>
                </div>

                {/* Master Confirmation Checkbox */}
                <label className="compliance-confirm-wrap">
                  <input
                    type="checkbox"
                    checked={masterConfirmed}
                    disabled={!allPoliciesAgreed}
                    onChange={(e) => setMasterConfirmed(e.target.checked)}
                  />
                  <span>
                    I confirm that I have reviewed, understood, and accept the <strong>Terms of Use</strong>, <strong>Merchant Disclaimer</strong>, and <strong>Privacy Policy</strong> issued by LBN MD320 Society.
                  </span>
                </label>
              </div>

              {/* Delivery Notice */}
              <div className="delivery-notice">
                <strong>Delivery Timeline:</strong> Automated confirmation is dispatched upon application submission, pending subscription payment and admin approval. Approved membership cards feature an estimated delivery time of 1 month to the postal address.
              </div>

              {/* Submit Button (Locked until KYC + all 3 policies are agreed) */}
              <button 
                type="submit" 
                className="btn-submit-lux" 
                disabled={loading || !isAadhaarVerified || !allPoliciesAgreed || !masterConfirmed}
                style={{
                  opacity: (!isAadhaarVerified || !allPoliciesAgreed || !masterConfirmed) ? 0.6 : 1,
                  cursor: (!isAadhaarVerified || !allPoliciesAgreed || !masterConfirmed) ? 'not-allowed' : 'pointer'
                }}
              >
                {loading ? 'Submitting Application...' : 'Submit Application'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}